import {create} from 'zustand';

export type ChatGate = 'none' | 'verifying' | 'error' | 'disabled' | 'notRegistered';

type ChatVerifyStore = {
  gate: ChatGate;
  setGate: (gate: ChatGate) => void;
};

export const useChatVerifyStore = create<ChatVerifyStore>(set => ({
  gate: 'none',
  setGate: gate => set({gate}),
}));
